export class SettingArea {
    settingAreaId: string;
    name: string;
}
export class DeliveryGroup {
    deliveryGroupId!: string;
    name!: string;
    editedDate!: string;
}

export class ApprovalDeliveryGroup {
    approvalDeliveryGroupId!: string;
    deliveryGroup!: DeliveryGroup;
    editedDate!: string;
}

export class ApprovalRule {
    approvalRuleId!: string;
    name?: string;
    trigger?: number;
    item?: number;
    action?: number;
    enabled?: boolean;
    editedDate?: string;
    approvalDeliveryGroups?: ApprovalDeliveryGroup[];
}
export class ApprovalDeliveryGroupModel {
    id?: string;
    deliveryGroupId?: string;
    userDeliveryGroupId?: string;
    name: string;
    email: string;
    userDeliveryGroups: ApprovalDeliveryGroupValue[];
    active?: boolean;
    parentId?: string;
    hasItems?: boolean;
}
export class ApprovalDeliveryGroupValue {
    userDeliveryGroupId?: string | null;
    user?: deliveryGroupUser | null;
}
export interface deliveryGroupProfileContact {
    profileContactId: string | null;
    firstName: string | null;
    lastName: string | null;
    fullName: string | null;
    email: string | null;
}

export interface deliveryGroupUser {
    organisationId: string | null;
    profileContact: deliveryGroupProfileContact | null;
    userId: string | null;
    isFirstLogon: boolean | null;
    isExpired: boolean | null;
    isLockedOut: boolean | null;
    failedLogonAttempts: number | null;
    hasAcceptedTofU: boolean | null;
    isDisabled: boolean | null;
    isDemoUser: boolean | null;
}

export interface Approval {
    approvalId: string;
    initiator: string;
    startDate: any; // or Date if you want to parse it
    trigger: KeyValue;
    item: KeyValue;
    action: KeyValue;
    state: KeyValue;
    name: string;
    type: string;
}

export interface KeyValue {
    key: number;
    value: string;
}
